import { commonService } from '../../_services'
const floorService = commonService('api/v1/floor')

const initialState = {
  all: { items: [] },
  loading: false,
}

const deepCloneInitial = JSON.parse(JSON.stringify(initialState))

export const floors = {
  namespaced: true,
  state: deepCloneInitial,
  actions: {
    async getAll(context: any): Promise<void> {
      context.commit('GET_ALL_REQUEST')

      return floorService.getAll().then((resp) => {
        context.commit('GET_ALL_SUCCESS', resp.data)
      }).catch(errorMsg => {
        context.commit('GET_ALL_FAILURE')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
      })
    },
    async addOne(context: any, data: any): Promise<void> {
      context.commit('ADD_REQUEST')

      return floorService.addOne(data).then((resp) => {
        // Fetch just added data
        floorService.getOne(resp.data._id).then(singleData => {
          context.commit('ADD_ITEM_SUCCESS', singleData.data)
        })
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async updateOne(context: any, payload: any): Promise<void> {
      const { preventLoading, ...data } = payload
      if (!preventLoading) {
        context.commit('UPDATE_REQUEST')
      }

      return floorService.updateOne(data).then((resp) => {
        return floorService.getOne(resp.data._id).then(singleData => {
          context.commit('UPDATE_ITEM_SUCCESS', singleData.data)
          return Promise.resolve(singleData.data)
        })
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async deleteOne(context: any, data: any): Promise<void> {
      context.commit('DELETE_REQUEST')
      return floorService.deleteOne(data._id).then((resp) => {
        context.commit('DELETE_ITEM_SUCCESS', data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async hasRefs(context: any, data: any): Promise<void> {
      context.commit('GET_REQUEST')
      return floorService.hasRefs(data._id).then((resp) => {
        context.commit('GET_REQUEST_SUCCESS', resp.data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
      })
    },
    async uploadFile(context: any, file: File): Promise<void> {
      context.commit('FILE_UPLOADING')
      return floorService.uploadFile(file).then((resp) => {
        context.commit('UPLOAD_FINISHED')
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async importCSV(context: any, file: File): Promise<void> {
      context.commit('CSV_UPLOADING')
      return floorService.importCSV(file).then((resp) => {
        context.commit('CSV_UPLOAD_FINISHED')
        // Reload list data
        context.dispatch('getAll')
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
  },
  mutations: {
    GET_ALL_REQUEST(state: any) {
      state.loading = true
    },
    GET_ALL_SUCCESS(state: any, allItems: any[]) {
      state.all = { items: allItems.map(item => item) }
      state.loading = false
    },
    GET_ALL_FAILURE(state: any) {
      state.all = { items: [] }
      state.loading = false
    },
    GET_REQUEST(state: any) {
      state.loading = true
    },
    GET_REQUEST_SUCCESS(state: any) {
      state.loading = false
    },
    ADD_REQUEST(state: any) {
      state.loading = true
    },
    UPDATE_REQUEST(state: any) {
      state.loading = true
    },
    DELETE_REQUEST(state: any) {
      state.loading = true
    },
    ADD_ITEM_SUCCESS(state: any, item: any) {
      state.all.items.push(item)
      state.loading = false
    },
    UPDATE_ITEM_SUCCESS(state: any, item: any) {
      state.all.items = state.all.items.map(tmp => {
        return tmp._id === item._id ? item : tmp
      })

      state.loading = false
    },
    DELETE_ITEM_SUCCESS(state: any, item: any) {
      const index = state.all.items.indexOf(item)
      state.all.items.splice(index, 1)
      state.loading = false
    },
    CSV_UPLOADING(state: any) {
      state.loading = true
    },
    CSV_UPLOAD_FINISHED(state: any, item: any) {
      state.loading = false
    },
    FILE_UPLOADING(state: any) {
      state.loading = true
    },
    UPLOAD_FINISHED(state: any, item: any) {
      state.loading = false
    },
    REQUEST_ERROR(state: any) {
      state.loading = false
    },
    RESET_STATE(state: any) {
      const init = JSON.parse(JSON.stringify(initialState))
      Object.keys(init).forEach(key => {
        state[key] = init[key]
      })
    },
  },
  getters: {
    canEdit: state => () => {
      return floorService.canEdit()
    },
    canDelete: state => () => {
      return floorService.canDelete()
    }
  },
}
